var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08667 2.37995C5.20626 2.31472 5.33333 2.41508 5.33333 2.5513V11.5732C5.33333 11.7311 5.22526 11.8644 5.08667 11.94V11.94L3.52 12.8333C2.42667 13.46 1.52667 12.94 1.52667 11.6733V5.18662C1.52667 4.76662 1.82667 4.24662 2.2 4.03329L5.08667 2.37995V2.37995Z",
    fill: "#717680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7219 4.02236C9.89223 4.10672 10 4.28035 10 4.47043V12.8704C10 13.2389 9.61495 13.4808 9.28298 13.3209L6.78298 12.1164C6.60998 12.0331 6.5 11.858 6.5 11.666V3.23233C6.5 2.86147 6.88956 2.61968 7.2219 2.78427L9.7219 4.02236Z",
    fill: "#717680"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4.32655V10.8132C14.6667 11.2332 14.3667 11.7532 13.9933 11.9665L11.9153 13.1575C11.582 13.3485 11.1667 13.1079 11.1667 12.7237V4.31687C11.1667 4.13735 11.2629 3.97162 11.4188 3.88263L12.6733 3.16655C13.7667 2.53988 14.6667 3.05988 14.6667 4.32655Z",
    fill: "#717680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.c4fdcdd4693cf0a380e36b4390af8b96.svg";
export { ForwardRef as ReactComponent };